import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import bckWoop from "@/assets/Logo-AppWhoop.webp";
import { scrollToTop, formatFechaHoraEvento } from "@/lib/utilsUI";
import { parseUTCDate, DEFAULT_TIMEZONE } from "@/utils/dateHelpers";
import { getColorByEstadoInvitacion } from "@/utils/invitacionUtils";

export default function TicketCardInvitacion({ ticket }) {
  const colores = getColorByEstadoInvitacion(ticket?.estado);

  const formatDatetime = ticket?.fechaHoraInicio
    ? formatFechaHoraEvento(
        parseUTCDate(
          ticket.fechaHoraInicio,
          ticket.eventoZonaHoraria || DEFAULT_TIMEZONE
        )?.toJSDate(),
        ticket.eventoZonaHoraria || DEFAULT_TIMEZONE
      )
    : ticket?.fechaHoraInicio
    ? formatFechaHoraEvento(
        parseUTCDate(ticket.fechaHoraInicio, DEFAULT_TIMEZONE)?.toJSDate(),
        DEFAULT_TIMEZONE
      )
    : "";

  const imagenSrc = ticket?.imgEvento || ticket?.eventoImg || bckWoop;
  const linkDestino = `/perfil/${ticket?.usuarioUid}/invitaciones/${ticket?.uid}`;

  return (
    <div className="min-w-[200px] max-w-[200px] bg-aw-bluedark rounded-b-xl shadow-lg overflow-hidden relative">
      {/* Badge de estado */}
      <div
        className={`absolute top-2 right-2 z-10 text-xs px-2 py-1 rounded-full font-semibold ${colores.badge}`}
      >
        {colores.label}
      </div>

      {/* Imagen del evento */}
      <Link
        to={linkDestino}
        onClick={scrollToTop}
        className="h-52 block overflow-hidden relative border-2 border-aw-green bg-aw-bluegray"
      >
        <img
          src={bckWoop}
          alt="Placeholder"
          className="absolute inset-0 w-2/3 h-2/3 m-auto top-0 left-0 object-cover z-0"
        />
        <LazyLoadImage
          src={imagenSrc}
          placeholderSrc={bckWoop}
          alt={ticket?.eventoNombre || "Evento"}
          height={"100%"}
          width={"100%"}
          effect="blur"
          className="w-full h-full object-cover z-50"
          loading="lazy"
        />
      </Link>

      <div className="px-2 py-1 flex flex-col justify-between h-[150px] text-center">
        <span className="text-tiny text-white capitalize">{formatDatetime}</span>
        <h3 className="font-bold text-sm text-white line-clamp-2">
          {ticket?.eventoNombre || "Evento"}
        </h3>
        <span className="text-xs text-aw-green font-semibold">
          {ticket?.tipoTicketNombre || ""}
        </span>
        <span className={`text-xs font-semibold ${colores.text}`}>
          {colores.label}
        </span>
      </div>

      {/* Boton ver invitacion */}
      <Link
        to={linkDestino}
        onClick={scrollToTop}
        className="w-full h-9 flex items-center justify-center text-black font-semibold text-sm mt-2 py-1 hover:scale-110 transition duration-300 bg-aw-green"
      >
        Ver Invitacion
        <FontAwesomeIcon
          icon="fa-solid fa-envelope-open-text"
          className="ml-2"
        />
      </Link>
    </div>
  );
}
